import { useMemo } from 'react';
import { useMailSignals } from './useMailSignals';

/**
 * Sidebar badge: unread count of the signed-in user's OWN mailbox(es) — shared
 * mailboxes are excluded so the badge reflects mail addressed to them.
 */
export function useUnreadCount(user, { enabled = true } = {}) {
  const email = enabled ? user?.email || null : null;
  const { mailboxes } = useMailSignals(email);

  return useMemo(() => {
    if (!email || !mailboxes) return 0;
    return Object.entries(mailboxes).reduce((sum, [key, signal]) => {
      if (!String(key).startsWith('own:')) return sum;
      const n = Number(signal?.inboxUnread);
      return sum + (Number.isFinite(n) && n > 0 ? n : 0);
    }, 0);
  }, [email, mailboxes]);
}

export default useUnreadCount;
